export const ValidateNumeric = (event) => {
    const value = event.target.value;
    if (value.length === 0) return;

    const lastDigit = value[value.length - 1];
    const reg = new RegExp('^[0-9]+$');
    if (!reg.test(lastDigit)) {
        event.target.value = value.slice(0, -1);
    }
}

export const FormatExpiryDate = (event, expiryDate) => {
    let date = event.target.value;
    if (date.length === 2 && expiryDate.length === 1) {
        event.target.value = date + '/';
    }
    else if (date.length === 3 && expiryDate.length === 2) {
        event.target.value = expiryDate + '/' + date[date.length - 1];
    }
}

export const FormatCardNumber = (event) => {
    let value = event.target.value.replace(/ /g, '');
    if (value.length < 4) return;
    let splittedArr = value.match(/.{1,4}/g);
    event.target.value = splittedArr.join(' ');
}